import { ExclamationCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { UpgradeRuleValidateInfoResponse } from '@openapi';
import { Button, Modal, Tabs } from 'antd';
import React from 'react';

const { TabPane } = Tabs;

const WarningModal: React.FC<{
  visible: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  warningData?: UpgradeRuleValidateInfoResponse;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  accessTab: string;
  handleNext: () => void;
}> = ({ visible, onCancel, onSubmit, warningData, activeTab, setActiveTab, accessTab, handleNext }) => (
  <Modal
    style={{ top: '25%' }}
    title={
      <>
        <WarningOutlined style={{ color: '#faad14', marginRight: '8px' }} />
        Warning Update Modal
      </>
    }
    onCancel={onCancel}
    visible={visible}
    footer={
      <Button onClick={activeTab === '3' ? onSubmit : handleNext}>{activeTab === '3' ? 'Update' : 'Next'}</Button>
    }
  >
    <Tabs activeKey={activeTab} onChange={setActiveTab}>
      <TabPane
        style={{ maxHeight: '200px', overflowY: 'auto' }}
        tab="Affected Groups"
        key="1"
        forceRender
        disabled={parseInt(accessTab) < 1}
      >
        {warningData?.groups?.map((item: any, index: number) => (
          <div key={index}>
            <ExclamationCircleOutlined style={{ color: '#faad14', marginRight: '8px' }} />
            <span>{item}</span>
          </div>
        ))}
      </TabPane>
      <TabPane tab="Devices" key="2" forceRender disabled={parseInt(accessTab) < 2}>
        <div>
          <ExclamationCircleOutlined style={{ color: '#faad14', marginRight: '8px' }} />
          <span>{`Devices number: ${warningData?.deviceNumber}`}</span>
        </div>
      </TabPane>
      <TabPane tab="Attached to default group" key="3" forceRender disabled={parseInt(accessTab) < 3}>
        <div>
          <ExclamationCircleOutlined style={{ color: '#faad14', marginRight: '8px' }} />
          {warningData?.attachedToDefaultGroup ? 'Attached to default group' : 'Not attached to default group'}
        </div>
      </TabPane>
    </Tabs>
  </Modal>
);

export default WarningModal;
